export enum ForWhomEnum {
  ME = 'me',
  ME_MORE = 'me-more',
  NOT_ME = 'not-me'
}

export enum GTMBranchesEnum {
  HEALTH = 'salud',
  DENTAL = 'dental',
  PETS = 'mascotas',
  LIFE = 'vida',
  TRAVEL = 'viajes',
  FOREIGN_HEALTH = 'salud-extranjeros'
}

export enum StartDateEnum {
  TODAY = 'today',
  TOMORROW = 'tomorrow',
  ANOTHER = 'another'
}

export enum MessageEnum {
  SUCCESS = 'success',
  INFO = 'info',
  ERROR = 'error',
  WARNING = 'warning',
  PENDING = 'pending',
  SUPPORT = 'support'
}

export enum ButtonTypeEnum {
  PRIMARY = 'primary',
  OUTLINE = 'outlined',
  TRANSPARENT = 'transparent'
}

export enum UserRoleEnum {
  HOLDER_INSURED = 'TA',
  HOLDER_NOT_INSURED = 'TN',
  INSURED = 'A'
}

export enum InsuranceState {
  CANCELLED = 1, // Firma cancelada
  REJECTED = 2, // Firma rechazada
  EXPIRED = 3, // Firma caducada
  SIGNED = 4, // Firma firmada pero no se ha podido realizar la llamada al servicio de emision
  ISSUED = 5, // Poliza emitida
  PENDING = 6, // poliza en tramite o en curso
  PENDING_EMISSION = 7, // poliza pendiente de emisión
  ABORTED = 8 // poliza anulada o caducada
}

export enum InsuranceStateName {
  CANCELLED = 'Cancelada', // Firma cancelada
  REJECTED = 'Rechazada', // Firma rechazada
  EXPIRED = 'Caducada', // Firma caducada
  SIGNED = 'Firmada', // Firma firmada pero no se ha podido realizar la llamada al servicio de emision
  ISSUED = 'Emitida', // Poliza emitida
  PENDING = 'Pendiente', // poliza en tramite o en curso
  PENDING_EMISSION = 'Pendiente de emisión' // poliza pendiente de emisión
}

export enum InsuranceProcessStatusEnum {
  IN_PROCESS = 1, // En curso
  PENDING_SIGN = 2, // Pendiente de firma
  EMITTED = 3, // Emitida
  EXPIRED = 4, // Expirada
  LAPSED = 5, // Caducada
  PENDING_PAYMENT = 6, // Pendiente de pago
  PENDING_EMISSION = 7, // Pendiente de emision,
  ABORTED = 8 // poliza anulada o caducada
}

export enum InsuranceProcessStatusDescriptionEnum {
  IN_PROCESS = 'En curso', // En curso
  PENDING_SIGN = 'Pendiente de firma', // Pendiente de firma
  EMITTED = 'Emitida', // Emitida
  EXPIRED = 'Expirada', // Expirada
  LAPSED = 'Caducada', // Caducada
  PENDING_PAYMENT = 'Pendiente de pago' // Pendiente de pago
}

export enum ErrorDisplayTypeEnum {
  NONE = 0,
  TOAST = 1,
  MODAL = 2,
  TOAST_IN_MODAL = 3,
  WITHOUT_TOAST = 4
}

export enum AddressTypeEnum {
  GENERATED = 'generated',
  NORMALIZED = 'normalized'
}

export enum ServiceErrorCodeEnum {
  SIGNATURE_WITHOUT_ALL_DOCUMENTS = 'Signature001'
  // ..
}

export enum DXPConfigPathEnum {
  PYMES = '/dxp-configs/dxp-config-pymes.json',
  PYMES_HEALTH = '/dxp-configs/dxp-config-pymes-health.json'
}
